module.exports = __webpack_public_path__ + "static/media/demo.7bd1eb70.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/demo.jpeg
// module id = 556
// module chunks = 4